import { createApp } from 'vue'
import App from './App.vue'
import './assets/css/main.css'

import 'animate.css';


createApp(App).mount('#app')
